export const PENDING_SALES_ORDER_PDF_DOWNLOAD_TITLE =
  "Pending sales orders cannot be downloaded until they are approved.";

/** Menu row for the sales order PDF. The label is the order number, for example GSO-202859. */
export function salesOrderDocumentMenuLabel(orderNumber: string): string {
  const trimmed = orderNumber.trim();
  return trimmed === "" ? "Sales order" : trimmed;
}

/** Menu row for one invoice, for example GOSI 19882. */
export function gosiInvoiceMenuLabel(invoiceNumber: string): string {
  const trimmed = invoiceNumber.trim();
  if (trimmed === "") {
    return "GOSI";
  }
  if (/^gosi\b/i.test(trimmed)) {
    return trimmed.replace(/^gosi/i, "GOSI");
  }
  return `GOSI ${trimmed}`;
}
